import React, { useRef, } from 'react';
import { useMutation, gql } from '@apollo/client';
import { Button, Spinner, toaster, Pane, TextareaField } from 'evergreen-ui';
import Cookies from 'js-cookie';

const COMPLAINT_RESPOND = gql`
  mutation Complaint_addChatMessage($complaintAddChatMessageId: ID!, $message: ComplaintChatMessageInput!) {
    complaint_addChatMessage(id: $complaintAddChatMessageId, message: $message) {
      code
      success
      error
    }
  }
`;

function ChatInput({ complaintId }) {
  const accessTokenValue = Cookies.get('userAccessToken');
  const [complaintRespond, { loading }] = useMutation(COMPLAINT_RESPOND);
  const msgRef = useRef();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await complaintRespond({
        variables: {
          complaintAddChatMessageId: complaintId,
          message: {
            img: null,
            msgType: 'txt',
            txt: msgRef.current.value,
          },
        },
        context: {
          headers: {
            Authorization: `Bearer ${accessTokenValue}`,
          },
        },
      });
      toaster.success("Response sent");
      window.location.reload()
      msgRef.current.value = ''; // Clear the input field after successful submission
    } catch (error) {
      toaster.danger(error.message);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ display: "flex", alignItems: "center" }}>
      <Pane flex="1">
         <TextareaField
           ref={msgRef}
           placeholder="Type your response here"
           required
           style={{ flex: "1" }}
          />
      </Pane>
      <Button style={{
        height:"42px",
        marginTop:"-10px"
      }} type="submit" disabled={loading} appearance="primary" intent="success" marginLeft={8}>
        {loading ? <Spinner size={16} /> : <i className="material-icons">send</i>}
      </Button>
    </form>
  );
}

export default ChatInput;
